import { Component, OnInit, EventEmitter, Output, ViewChild, AfterViewInit } from '@angular/core';
import { AccountInfo } from 'src/app/shared-core/models/auth-data.model';
import { AuthService } from 'src/app/shared-core/services/auth.service';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import Validation from 'src/app/cart/shared/utils/validation';
import { ToastService } from 'ng-uikit-pro-standard';
import { hasError, VistekValidation } from 'src/app/shared-core/services/validation.service';
import { GtagService } from 'src/app/shared-core/services/gtag.service';

@Component({
  selector: 'app-create-account',
  templateUrl: './create-account.component.html',
  styleUrls: ['./create-account.component.scss'],
})
export class CreateAccountComponent implements OnInit, AfterViewInit {
  constructor(
    private authService: AuthService,
    private gtagService: GtagService,
    private formBuilder: FormBuilder,
    private toaster: ToastService
  ) {}

  @Output() accountCreated: EventEmitter<string> = new EventEmitter<string>();
  @Output() accountExistsAction: EventEmitter<'login' | 'passwordreset'> = new EventEmitter<
    'login' | 'passwordreset'
  >();

  signupForm: FormGroup;
  get f(): { [key: string]: AbstractControl } {
    return this.signupForm.controls;
  }

  public myColors = ['#DD2C00', '#FF6D00', '#FFD600', '#AEEA00', '#00C853'];
  public thresholds = [90, 75, 45, 25];
  public strengthLabels = ['(Useless)', '(Weak)', '(Normal)', '(Strong)', '(Great!)'];

  submitted: boolean = false;
  errorMessage: string = '';
  returnURl: string = '';
  passowrdTextType: boolean;
  confirmPassowrdTextType: boolean;
  passowrdMeter: string = '';

  ngAfterViewInit() {
    this.signupForm.value.password = '';
  }

  ngOnInit(): void {
    this.signupForm = new FormGroup(
      {
        firstname: new FormControl(null, [Validators.required, Validators.minLength(2), Validators.pattern(/^(?=.*\S)[a-zA-ZÀ-ÿ\s\-\'.]+$/)]),
        lastname: new FormControl(null, [Validators.required, Validators.minLength(2), Validators.pattern(/^(?=.*\S)[a-zA-ZÀ-ÿ\s\-\'.]+$/)]),
        email: new FormControl(
          null,
          [Validators.required, Validators.maxLength(80), VistekValidation.email()],
          [VistekValidation.emailExists(this.authService)]
        ),
        password: new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(40)]),
        confirmpassword: new FormControl(null, [Validators.required]),
      },
      {
        validators: [Validation.match('password', 'confirmpassword')],
      }
    );
  }

  togglePasswordTextType() {
    this.passowrdTextType = !this.passowrdTextType;
  }
  toggleconfirmPasswordTextType() {
    this.confirmPassowrdTextType = !this.confirmPassowrdTextType;
  }
  resetForm(): void {
    this.submitted = false;
    this.signupForm.reset();
  }
  hasError = (formControlName: string, error: string | string[]): boolean => {
    return hasError(this.signupForm, formControlName, error);
  };

  onSubmit() {
    this.errorMessage = '';
    this.submitted = true;
    if (this.signupForm.invalid) {
      return;
    }

    let accountInfo = new AccountInfo();
    accountInfo.FirstName = this.signupForm.value.firstname;
    accountInfo.LastNameField = this.signupForm.value.lastname;
    accountInfo.Email = this.signupForm.value.email;
    accountInfo.PasswordHidden = btoa(this.signupForm.value.password);
    accountInfo.ConfirmPasswordHidden = btoa(this.signupForm.value.confirmpassword);
    accountInfo.RememberMe = true;
    this.authService.signup(accountInfo).subscribe((res) => {
      if (res.Success === false) {
        if (res.Errors) this.errorMessage = res.Errors[0];
      } else {
        this.gtagService.signUp('Vistek');
        let successMsg = ' Account created successfully. ';
        this.toaster.success(successMsg, null, {
          enableHtml: true,
        });
        this.accountCreated.emit(successMsg);
        this.resetForm();
        window.location.reload();
      }
    });
  }

  onAccountExists(event: UIEvent, action: 'login' | 'passwordreset') {
    event.preventDefault();
    this.accountExistsAction.emit(action);
  }
}
